import { render } from "./AttrGantt.vue?vue&type=template&id=5b5a495c&scoped=true"
import script from "./AttrGantt.vue?vue&type=script&lang=js"
export * from "./AttrGantt.vue?vue&type=script&lang=js"

import "./AttrGantt.vue?vue&type=style&index=0&id=5b5a495c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5a495c"],['__file',"src/components/widgets/components_core/AttrGantt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b5a495c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b5a495c', __exports__)) {
    api.reload('5b5a495c', __exports__)
  }
  
  module.hot.accept("./AttrGantt.vue?vue&type=template&id=5b5a495c&scoped=true", () => {
    api.rerender('5b5a495c', render)
  })

}


export default __exports__